import { render, staticRenderFns } from "./organization-show.vue?vue&type=template&id=74d94ac8&scoped=true&"
import script from "./organization-show.vue?vue&type=script&lang=js&"
export * from "./organization-show.vue?vue&type=script&lang=js&"
import style0 from "./organization-show.vue?vue&type=style&index=0&id=74d94ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d94ac8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d94ac8')) {
      api.createRecord('74d94ac8', component.options)
    } else {
      api.reload('74d94ac8', component.options)
    }
    module.hot.accept("./organization-show.vue?vue&type=template&id=74d94ac8&scoped=true&", function () {
      api.rerender('74d94ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizations/organization-show.vue"
export default component.exports